module.exports = __webpack_public_path__ + "static/media/baemingo_logo_white.c1fa1b27.svg";